export enum ArticleVisibility {
  BOTH = 'BOTH',
  LOGGED_IN = 'LOGGED_IN',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN'
}
